export default () => ({
  accountButton: {
    color: '#fff',
  },
});
